var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVocationalTechnicalSchool({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.537,
    height: 23.847,
    viewBox: "0 0 23.537 23.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f003c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "square_foot_FILL0_wght400_GRAD0_opsz48",
    className: "cls-1",
    d: "M8.827,32.108A2.836,2.836,0,0,1,6,29.281V10.232a1.8,1.8,0,0,1,1.219-1.8,1.86,1.86,0,0,1,2.173.459l1.59,1.59L9.5,11.964l.954.954,1.484-1.484,4.135,4.135-1.484,1.484.954.954,1.484-1.484,4.17,4.17-1.484,1.484.954.954,1.484-1.484,4.135,4.135L24.8,27.266l.954.954,1.484-1.484,1.59,1.59a2.1,2.1,0,0,1,.53,2.421,1.938,1.938,0,0,1-1.944,1.361Zm0-2.827H25.19L8.827,12.918Z",
    transform: "translate(-6 -8.261)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVocationalTechnicalSchool);
export default __webpack_public_path__ + "static/media/vocational-technical-school.aa6c72614ae875409f36e56f36e85b09.svg";
export { ForwardRef as ReactComponent };